'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('redux-form/immutable');

var _authClientComponent = require('@wh/auth-client-component');

var _authClientComponent2 = _interopRequireDefault(_authClientComponent);

var _uiComponents = require('@wh/ui-components');

var _reduxDeviceDetection = require('@wh/redux-device-detection');

var _accountRecovery = require('../account-recovery');

var _accountRecovery2 = _interopRequireDefault(_accountRecovery);

var _inputGroup = require('../input-group');

var _inputGroup2 = _interopRequireDefault(_inputGroup);

var _checkboxes = require('../checkboxes');

var _checkboxes2 = _interopRequireDefault(_checkboxes);

var _constants = require('./../constants');

require('./login-form.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The LoginForm properties type
 * @type {Object}
 */
var _ref2 = (0, _jsx3.default)(_accountRecovery2.default, {});

var _ref3 = (0, _jsx3.default)(_checkboxes2.default, {});

/**
 * Login Form component
 * @param {LoginFormPropsType} props The properties object.
 * @returns {Element} React element
 */
var LoginForm = function (_Component) {
    (0, _inherits3.default)(LoginForm, _Component);

    function LoginForm(props) {
        (0, _classCallCheck3.default)(this, LoginForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call(this, props));

        _this.setPasswordInputRef = function (ref) {
            _this.passwordInputRef = ref;
        };

        _this.focusPasswordOnEnterKeyDown = function (e) {
            if (e.keyCode === 13 || e.which === 13) {
                e.preventDefault();
                e.stopPropagation();
                _this.passwordInputRef.focus();
            }
        };

        _this.submitLoginForm = function (formData) {
            _this.props.submitLoginForm(formData, _this.props.casClient);
        };

        _this.trackEventFieldInteract = function (e) {
            var fieldName = e.target.name;
            var interactElements = _this.state.interactElements;

            if (interactElements[fieldName] === false) {
                _this.props.trackingEvent(_constants.TRACKING_EVENT_NAME_FORM_INTERACT, {
                    formFieldName: fieldName
                });
                interactElements[fieldName] = true;
                _this.setState({
                    interactElements: interactElements
                });
            }
        };

        _this.clearFieldInteract = function (e) {
            var fieldName = e.target.name;
            var interactElements = _this.state.interactElements;

            interactElements[fieldName] = false;
            _this.setState({
                interactElements: interactElements
            });
        };

        _this.deviceDetector = (0, _reduxDeviceDetection.getDeviceInfo)();

        _this.state = {
            interactElements: {
                username: false,
                password: false
            }
        };
        return _this;
    }

    (0, _createClass3.default)(LoginForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var valid = _ref.valid,
                submitFailed = _ref.submitFailed,
                submitSucceeded = _ref.submitSucceeded;

            if (valid && !submitFailed && !submitSucceeded) {
                this.formIsValid();
            }
        }

        /**
         * Stores a reference to the password input DOM element
         * @param {Object} ref DOM element
         * @returns {void}
         */


        /**
         * Detect if enter was pressed in username field and then move focus to password field
         * @param {Object} e onkeydown event
         * @returns {void}
         */

    }, {
        key: 'formIsValid',
        value: function formIsValid() {
            this.props.trackingEvent(_constants.TRACKING_EVENT_NAME_FORM_COMPLETE);
        }

        /**
         * Submit login form callback
         * @param {Object} formData Redux form input data
         * @returns {void}
         */


        /**
         * Fires tracking event when user interacts with a form field
         * @param {Object} e event
         * @returns {void}
         */


        /**
         * Clears information that user interacted with a field
         * @param {Object} e event
         * @returns {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                t = _props.t,
                handleSubmit = _props.handleSubmit,
                invalid = _props.invalid,
                submitting = _props.submitting;


            return (0, _jsx3.default)('section', {
                className: 'c-login-form'
            }, void 0, (0, _jsx3.default)('form', {
                onSubmit: handleSubmit(this.submitLoginForm)
            }, void 0, (0, _jsx3.default)(_immutable.Field, {
                name: 'username',
                type: 'text',
                component: _inputGroup2.default,
                label: t('login')('modalLabelUsername'),
                id: 'login-form-username',
                autoCapitalize: 'none',
                autoComplete: this.deviceDetector.info.os !== 'desktop' ? 'off' : 'username',
                autoCorrect: 'off',
                isAutofocused: true,
                isSpellchecked: false,
                onKeyDown: this.focusPasswordOnEnterKeyDown,
                onChange: this.trackEventFieldInteract,
                onBlur: this.clearFieldInteract
            }), (0, _jsx3.default)(_immutable.Field, {
                name: 'password',
                type: 'password',
                component: _inputGroup2.default,
                label: t('login')('modalLabelPassword'),
                id: 'login-form-password',
                autoCapitalize: 'none',
                autoComplete: 'off',
                autoCorrect: 'off',
                isSpellchecked: false,
                refCallback: this.setPasswordInputRef,
                onChange: this.trackEventFieldInteract,
                onBlur: this.clearFieldInteract
            }), _ref2, (0, _jsx3.default)(_uiComponents.NavItem, {
                type: 'button',
                style: 'success',
                isExpanded: true,
                className: 'c-login-form__submit-button',
                disabled: Boolean(invalid || submitting)
            }, void 0, t('login')('modalLoginButtonText')), _ref3));
        }
    }]);
    return LoginForm;
}(_react.Component);

exports.default = LoginForm;
//# sourceMappingURL=login-form.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-form/login-form.js
// module id = 491
// module chunks = 0